import React from 'react';
import { Box } from '@mui/material';
import { launchColors } from '../launchTheme';

interface Props {
  value: number | null;
  size?: number;
  color?: string;
}

const ProgressRing: React.FC<Props> = ({ value, size = 84, color = launchColors.moss }) => {
  const stroke = Math.max(5, Math.round(size / 10));
  const radius = size / 2 - stroke / 2 - 1;
  const circumference = 2 * Math.PI * radius;
  const known = value != null;
  const percent = known ? Math.max(0, Math.min(100, Math.round(value))) : 0;
  return (
    <Box
      component="svg"
      role="img"
      aria-label={known ? `Framdrift ${percent} procent` : 'Framdrift okänd'}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      sx={{ flexShrink: 0, display: 'block' }}
    >
      <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke={launchColors.softNavy} strokeWidth={stroke} />
      {known && percent > 0 && (
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={`${(percent / 100) * circumference} ${circumference}`}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      )}
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dominantBaseline="central"
        style={{ fontSize: Math.max(11, Math.round(size / 4.6)), fontWeight: 700, fill: launchColors.navy, fontVariantNumeric: 'tabular-nums' }}
      >
        {known ? `${percent} %` : '–'}
      </text>
    </Box>
  );
};

export default ProgressRing;
